var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-info"},[(_vm.page)?_c('page-infomation',{attrs:{"page":_vm.page}}):_vm._e(),(_vm.page)?_c('page-positions',{attrs:{"page":_vm.page}}):_vm._e(),(_vm.page)?_c('page-prices',{attrs:{"page":_vm.page}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }